export default __webpack_public_path__ + "static/9_9-2015813638ae59bc11a1f256dc032b0a.png";